import { Pipe, PipeTransform } from '@angular/core';
import { DiscountType, PromoCode } from '../domain/registrator';

@Pipe({
  name: 'discountValue'
})
export class DiscountValuePipe implements PipeTransform {

  transform(promoCode: PromoCode): string {
    if (promoCode) {
      if (promoCode.discountType === 'PERCENT') {
        return `${promoCode.discountValue.toFixed(2)}%`;
      } else if (promoCode.discountType === 'FIXED_AMOUNT') {
        return `${promoCode.discountValue.toFixed(2)}€`;
      }
    }
    return 'N/A';
  }

}
